export const HOUR = 3600000;
export const RULES_VERSION = "tmj-2026-10-13-v2";
export const PRIVACY_VERSION = "tmj-2026-10-13-v2";

export function formatTmjTime(value: number) {
  return new Intl.DateTimeFormat("hu-HU", { timeZone: "Europe/Budapest", dateStyle: "long", timeStyle: "short" }).format(value);
}

/** Convert Budapest wall time per date, rather than reuse today's browser offset. */
export function budapestTime(date: string, time: string) {
  const target = Date.parse(`${date}T${time}:00Z`);
  if (!Number.isFinite(target)) throw new Error("Érvénytelen dátum.");
  const formatter = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Budapest", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });
  let result = target;
  for (let i = 0; i < 3; i++) {
    const wall = formatter.format(result).replace(" ", "T");
    result += target - Date.parse(`${wall}Z`);
  }
  if (formatter.format(result).slice(0, 16) !== `${date} ${time}`) throw new Error("Ez a helyi időpont nem létezik.");
  return result;
}

export function retentionDate(startAt: number) {
  const date = new Date(startAt);
  date.setUTCFullYear(date.getUTCFullYear() + 1);
  return date.getTime();
}
